import React from "react";
import truncate from "html-truncate";
import PropTypes from "prop-types";
import BlogArticleCard from "./BlogArticleCard";

const BlogArticleCardCosmic = ({ article }) => {
  const truncatedText = article.metadata.text
    ? truncate(article.metadata.text, 200)
    : "";

  return (
    <BlogArticleCard article={article} imageClassName="md:min-h-full md:w-full">
      <h3 className="text-md items-start mb-3 font-bold">{article.title}</h3>
      <div
        className="lg:grow"
        dangerouslySetInnerHTML={{ __html: truncatedText }}
      />
    </BlogArticleCard>
  );
};

BlogArticleCardCosmic.propTypes = {
  article: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    metadata: PropTypes.object,
  }).isRequired,
};
export default BlogArticleCardCosmic;
